export const debounce = (fn: () => void, delay: number): (() => void) => {
  let timeout: number | null = null;
  return () => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      fn();
      timeout = null;
    }, delay);
  };
};
